/**
 * Fabric inward worklist (garment, `garment.materials`) — cross-order incoming
 * materials to receive + inspect. Static route wins over `/floor/$stage`.
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { InwardPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/production/floor/inward")({
  component: InwardRoute,
});

function InwardRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[{ label: "Production", to: "/" }, { label: "Floor", to: "/production/floor" }, { label: "Fabric inward" }]}
    >
      <InwardPage />
    </WorkspaceShell>
  );
}
